/**
 * Assets: uvt-routine.js
 * -----------------------------------------------------------------------------
 * Pagination dots for the mobile card rail in sections/uvt-routine.liquid.
 * Uses uvt.initDots from uvt-base.js, which must load first.
 * Re-initialises when the section is re-rendered in the theme editor.
 *
 */
(() => {
  /**
   * Sets up the dots in every routine section inside a container.
   * @param {ParentNode} container - Document or re-rendered section.
   */
  function initAll(container) {
    if (!window.uvt) {
      return;
    }

    container.querySelectorAll('[data-uvt-routine]').forEach((root) => {
      window.uvt.initDots(
        root.querySelector('[data-uvt-rail]'),
        Array.from(root.querySelectorAll('[data-uvt-dot]')),
      );
    });
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
